/**
 * Whether an address change should trigger an express re-quote.
 *
 * Why broader than `isAvailable` (HL-9096, Bug 1): `expressDeliveryState.isAvailable` is seeded
 * once at page load and never recomputed. For `isExpressFlow=false` carts (notably video
 * consultations — `ShippingController` forces the flag false) it rides only on the *landing* zip's
 * next-day eligibility, so a customer who lands ineligible can never gain next_day by changing to
 * an eligible address. Cannabis carts can be next_day-eligible by zip regardless of `isExpressFlow`,
 * so re-quote whenever the cart is already known-available OR it's a cannabis catalog.
 */
export const shouldQuoteExpressOnAddressChange = (params: {
  isAvailable: boolean;
  isCannabisCatalog: boolean;
}): boolean => params.isAvailable || params.isCannabisCatalog;
